import store from 'store/Store';
import { isMultiStoreFilteringEnabledSelector } from 'viewModel/selectors/shopYourStore/isMultiStoreFilteringEnabledSelector';
import Storage from 'utils/localStorage/Storage';
import LOCAL_STORAGE from 'utils/localStorage/Constants';

/**
 * Returns the multi-store filtering query params sent to BXS / SXS /
 * Store Aggregation / PXS endpoints.
 *
 * @returns {{ nearbyStoresEnabled: boolean, includeNearbyStores: boolean }}
 *   - nearbyStoresEnabled: feature killswitch && A/B test
 *   - includeNearbyStores: user toggle from localStorage (IASP_INCLUDE_NEARBY_STORES)
 */
function getMultiStoreFilteringQueryParams() {
    const nearbyStoresEnabled = isMultiStoreFilteringEnabledSelector(store.getState());

    if (!nearbyStoresEnabled) {
        return { nearbyStoresEnabled: false, includeNearbyStores: false };
    }

    const includeNearbyStores = Sephora.isNodeRender
        ? false
        : !!Storage.local.getItem(LOCAL_STORAGE.IASP_INCLUDE_NEARBY_STORES);

    return { nearbyStoresEnabled, includeNearbyStores };
}

export { getMultiStoreFilteringQueryParams };
